import { API_REQUEST, BEGIN_PASSWORD_RESET, INIT_PWD_RESET, RESET_BEGIN_RESET, SUBMIT_PWD_RESET } from "../../actionTypes/actionsTypes";
import { AppAction } from "../../types";


export interface ResetPayload extends Record<string, unknown> {
    "search": string;
    "g-recaptcha-response": string;
}

export const beginReset = (payload: ResetPayload): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/user/security-q/`,
        next: BEGIN_PASSWORD_RESET,
        method: 'POST',
        data: payload
    }
});

export const resetBeginReset = () => ({
    type: RESET_BEGIN_RESET
});

export interface ResetSubmitPayload extends Record<string, unknown> {
    code?: number | string | unknown ;
    password?: string | unknown;
    conf_password?: string | unknown;
}

export const submitReset = (payload: ResetSubmitPayload, token: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/user/reset-finish/`,
        next: SUBMIT_PWD_RESET,
        method: 'POST',
        data: payload,
        authorization: token
    }
});

export interface AdminResetSubmitPayload extends Record<string, unknown> {
    password?: string | unknown;
    conf_password?: string | unknown;
}

export const submitReset2 = (payload: AdminResetSubmitPayload, token: string): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/user/reset-finish-2/`,
        next: SUBMIT_PWD_RESET,
        method: 'POST',
        data: payload,
        authorization: token
    }
});

export interface BeginResetPayload extends Record<string, unknown> {
    user_profile_id: number | string,
    security_a: string
}

export const inititatePasswordReset = (payload: BeginResetPayload): AppAction => ({
    type: API_REQUEST,
    payload: {
        url: `/user/reset-begin/`,
        next: INIT_PWD_RESET,
        method: 'POST',
        data: payload,
    }
})